module.exports = __webpack_public_path__ + "static/media/cow-pose.20422a54.mp4";